<template>
  <main-content-wrapper>
    <h1 class="text-md-center">
      Včlanitev v Tuš Cash & Carry klub
      <span>Postanite naš član in pridobite ugodnosti kluba</span>
    </h1>
    <template v-if="error">
      <v-alert
        :value="true"
        type="error"
      >
        Včlanitev trenutno ni mogoča. Prosimo, poskusite znova kasneje.
      </v-alert>
      <template v-if="registrationStep">
        <empty-space />
        <v-btn depressed @click="finishRegistration()" color="primary_action_small">Nadaljuj</v-btn>
      </template>
    </template>
    <template v-else-if="existingMember && !registrationStep">
      <v-alert
        :value="true"
        type="error"
      >
        Včlanitev za obstoječe člane ni na voljo.
      </v-alert>
      <empty-space />
      <v-btn depressed @click="goAccount()" color="primary_action_small">Nadaljuj na svoj račun</v-btn>
    </template>
    <template v-else-if="applicationSubmitted">
      <v-alert
        :value="true"
        type="info"
      >
        <template v-if="applicationState === 'completed'">
          Včlanitev je zaključena, povezava s spletnim profilom pa še ni urejena. Prosimo, obrnite se na podporo.
        </template>
        <template v-else-if="signingFailed">
          Vaša vloga za včlanitev je oddana. Pogodbe za podpis vam ni bilo mogoče poslati, zato vas bomo kontaktirali.
        </template>
        <template v-else>
          Vaša vloga za včlanitev je oddana. Pogodbo za podpis ste prejeli po e-pošti.
          Ko bo včlanitev zaključena, bo vaš profil samodejno aktiviran.
        </template>
      </v-alert>
      <empty-space />
      <v-btn v-if="registrationStep" depressed @click="finishRegistration()" color="primary_action_small">Nadaljuj</v-btn>
      <v-btn v-else depressed @click="goAccount()" color="primary_action_small">Nadaljuj na svoj račun</v-btn>
    </template>
    <template v-else>
      <inline-loader v-if="loading || existingMember"></inline-loader>
      <template v-if="!loading && url">
        <iframe ref="iframe" :src="url" width="100%" :height="iframeHeight + 'px'" frameborder="0"></iframe>
        <p v-if="registrationStep" class="text-md-center">
          <v-btn depressed @click="finishRegistration()" color="primary_action_small">Preskoči</v-btn>
        </p>
      </template>
    </template>
  </main-content-wrapper>
</template>

<script>

import MainContentWrapper from '../components/MainContentWrapper'
import { onBoardingService } from '../services'
import InlineLoader from '@/components/InlineLoader.vue'
import EmptySpace from '@/components/EmptySpace.vue'

export default {
  name: 'DigitalOnBoarding',
  components: { InlineLoader, MainContentWrapper, EmptySpace },
  data: vm => ({
    url: null,
    loading: true,
    error: null,
    existingMember: false,
    applicationState: null,
    signingFailed: false,
    // initial height until the iframe reports its content height
    iframeHeight: 1000
  }),
  computed: {
    // application already sent to CRM (pending, signing or completed without connected card)
    applicationSubmitted () {
      return ['pending', 'signing', 'completed'].indexOf(this.applicationState) > -1
    },
    // opened as the last step of registration (after consents)
    registrationStep () {
      return this.$route.query.korak === 'registracija'
    }
  },
  methods: {
    goAccount () {
      this.$router.push({ name: 'account' })
    },
    finishRegistration () {
      // continues the original flow: back to the application (flow session) or to the account page
      window.location.replace('/api/login-done')
    },
    iframeOrigin () {
      try {
        return new URL(this.url, window.location.href).origin
      } catch (e) {
        return null
      }
    },
    // postMessage events sent by the CRM onboarding iframe (digitalna-vclanitev:*)
    onMessage (e) {
      const iframe = this.$refs.iframe
      if (!iframe || !this.url || e.source !== iframe.contentWindow) return
      if (e.origin !== this.iframeOrigin()) return

      const msg = e.data
      if (!msg || typeof msg.type !== 'string') return

      switch (msg.type) {
        case 'digitalna-vclanitev:resize':
          if (typeof msg.height === 'number' && msg.height > 0) {
            this.iframeHeight = Math.ceil(msg.height)
          }
          break
        case 'digitalna-vclanitev:submitted':
          // application submitted, membership is completed after signing (checked by cron)
          this.signingFailed = msg.signingSent === false
          this.applicationState = 'pending'
          break
        case 'digitalna-vclanitev:redirect':
          if (typeof msg.url === 'string') {
            window.location.assign(msg.url)
          }
          break
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.onMessage)
  },
  mounted () {
    window.addEventListener('message', this.onMessage)
    onBoardingService.getIntegrationUrl().then((response) => {
      this.existingMember = !!response.existing_member
      this.applicationState = response.application_state || null
      this.url = response.url
      if (this.existingMember && this.registrationStep) {
        this.finishRegistration()
      }
    }, (error) => {
      console.log(error)
      this.error = error
    }).finally(() => {
      this.loading = false
    })
  }
}
</script>

<style scoped>

</style>
